import { Alignment, DivNumberInput } from "@/components/DivInput/DivNumberInput"
import { ManualVal } from "@/types/common"
import classNames from "classnames"
import { isObject, isNumber, isNil } from "lodash-es"
import { numberFixToStr, toDefaultUnitVal, toUnitVal, toUnitValStrWithFormat } from "./utils"
import { UnitEntity } from "@/services/unitSet/unitSet.model"
import { RunState, getStatus } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

interface ManualCellProps {
  readonly?: boolean
  cellData?: ManualVal
  dimCode?: string
  unitEntiry?: UnitEntity
  onChange?: (val: number) => void
  onDelete?: () => void
}
export function ManualCell(props: ManualCellProps) {
  const {readonly, cellData, onChange, onDelete, dimCode, unitEntiry} = props;
  const isManual = isObject(cellData) || isNil(cellData)
  const cellVal = isManual ? (cellData as ManualVal)?.val : cellData
  const value = isNumber(cellVal) ? toUnitValStrWithFormat(cellVal as number, unitEntiry) : cellVal
  const status = useSelector(getStatus)
  if (readonly || !isManual) {
    const manualColor = isManual && status !== RunState.Stop
    return <span className={ manualColor && 'manualInputRow'}>{numberFixToStr(value, unitEntiry?.cutoff) ?? '-'}</span>
  }

  const onValChanged = (val) => {
    const newVal = toDefaultUnitVal(val as number, unitEntiry?.unit)
    onChange?.(newVal)
  }

  return <DivNumberInput
    dimCode={dimCode}
    unitEntity={unitEntiry}
    value={value as number}
    removeAble={isObject(cellData)}
    align={Alignment.Center} className={classNames('editableDiv', isManual && 'manualInputRow')}
    onChange={onValChanged}
    onDelete={onDelete}
    style={{width: '100%'}}
  />
}
